import * as cn from "classnames";
import * as React from "react";
import * as styles from "./styles.css";
import GridColumn from "backpack-ui/dist/components/gridColumn";
var ArticleHeaderTitle = function (_a) {
    var children = _a.children;
    return (React.createElement(GridColumn, { className: cn("ArticleHeader--Title", styles.articleHeaderTitle), sm: 12, lg: 9, fluid: true }, children));
};
export default ArticleHeaderTitle;



//////////////////
// WEBPACK FOOTER
// ./app/modules/blog/components/articleHeaderTitle/index.tsx
// module id = BXK2
// module chunks = 3